import { Chip } from '../Chip';
import { getTypographyStyles, styled } from 'helpers';

import { Props } from './types';

export const ChoiceChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'hasIconOnRight',
})<Props>`
  border-radius: 1.5rem;
  flex-direction: ${({ hasIconOnRight }) => (hasIconOnRight ? 'row-reverse' : 'row')};

  &.MuiButtonBase-root {
    ${({ theme, isActive }) =>
      isActive
        ? `
      background: ${theme.palette.blue['A50']};
      border: 2px solid ${theme.palette.blue['800']};
      color: ${theme.palette.blue['800']};
      
      :hover {
        background: ${theme.palette.blue['50']};
      }
      
      .MuiSvgIcon-root {
        color: ${theme.palette.blue['800']};
      }
    `
        : `
      background: ${theme.palette.common.white};
      border: 2px solid ${theme.palette.grey['A100']};
      
      :hover {
        background: ${theme.palette.grey['A50']};
      }
    `}
    box-shadow: none;
  }

  .MuiChip-label {
    ${({ theme, isActive }) => isActive && getTypographyStyles('button', theme)}
    padding: 0 ${({ theme }) => theme.typography.pxToRem(16)};
  }

  .MuiChip-icon {
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    margin: ${({ hasIconOnRight }) => (hasIconOnRight ? '0 0.75rem 0 -0.5rem' : '0 -0.5rem 0 0.75rem')};
  }

  .MuiTouchRipple-root {
    display: none;
  }
`;

export default ChoiceChip;
